export const getEnv = () => {
    const hostname = window.location.hostname;
    return hostname.includes('acc-') || hostname.includes('localhost') ? 'ACC' : 'PROD'
}